<template>
	<login-layout>
    <template #content>
      <div class="login-form-wrap">
        <bread-crumbs :current="$route.meta.title"/>

        <h1 class="h1">{{ $route.meta.title }}</h1>

        <div v-for="(error, index) in errors" :key="index" class="alert alert-danger">{{ error }}</div>
        <div v-for="(message, index) in messages" :key="index" class="alert alert-success">{{ message }}</div>

        <form id="com-form-login" class="form-horizontal" @submit="sendRestoreEmail">

          <label class="login-input">
            <span>Логин</span>
            <input type="text"
                   v-model.trim="login"
                   placeholder="Email, например, user@sunsim.ru"
                   class="form-control mb-3">
          </label>

          <div class="submit-block">
            <div class="btn-line">
              <div v-if="loading" class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <button v-else type="submit" class="btn btn-primary">Отправить</button>
              <router-link :to="{name: 'LoginPage'}" class="btn btn-default">Войти по логину и паролю</router-link>
            </div>
          </div>
        </form>

      </div>
    </template>
  </login-layout>
</template>

<script>

import axios from 'axios';
import LoginLayout from "@/layouts/LoginLayout";
import BreadCrumbs from "@/components/login/BreadCrumbs";

export default {
  name: 'SendRestoreEmailPage',
  data() {
    return {
      loading: false,
      login: '',
      errors: [],
      messages: [],
    }
  },
  components: {
    LoginLayout,
    BreadCrumbs,
  },
  mounted() {
    const url = new URL(window.location);

    if (url.searchParams.get('email')) {
      this.login = url.searchParams.get('email');
    }
  },
  methods: {
    sendRestoreEmail(event) {
      event.preventDefault();

      this.errors = [];
      this.messages = [];
      this.loading = true;

      let params = {
        login: this.login,
      };

      axios.post(process.env.VUE_APP_ROOT_API + '/login/send-restore-email', params)
          .then(response => {
            this.loading = false;

            if (response.data) {
              this.messages.unshift(`На ваш почтовый ящик ${this.login} отправлено письмо, содержащее ссылку для сброса пароля`);
            } else {
              this.errors.unshift('Неизвестная ошибка');
            }
          })
          .catch(error => {
            this.loading = false;

            if (error.response && error.response.data && error.response.data.message) {
              this.errors.unshift(error.response.data.message);
            } else {
              this.errors.unshift(error);
            }
          });
    },
  },
}
</script>

<style scoped lang="less">
@import "../../assets/less/login-new.less";
</style>